export const PROFILE_CREATE_REQUEST = "PROFILE_CREATE_REQUEST";
export const PROFILE_CREATE_SUCCESS = "PROFILE_CREATE_SUCCESS";
export const PROFILE_CREATE_FAIL = "PROFILE_CREATE_FAIL";
export const PROFILE_CREATE_RESET = "PROFILE_CREATE_RESET";

export const PROFILE_EDIT_REQUEST = "PROFILE_EDIT_REQUEST";
export const PROFILE_EDIT_SUCCESS = "PROFILE_EDIT_SUCCESS";
export const PROFILE_EDIT_FAIL = "PROFILE_EDIT_FAIL";
export const PROFILE_EDIT_RESET = "PROFILE_EDIT_RESET";

export const PROFILE_UPDATE_REQUEST = "PROFILE_UPDATE_REQUEST";
export const PROFILE_UPDATE_SUCCESS = "PROFILE_UPDATE_SUCCESS";
export const PROFILE_UPDATE_FAIL = "PROFILE_UPDATE_FAIL";
export const PROFILE_UPDATE_RESET = "PROFILE_UPDATE_RESET";

export const PROFILE_LIST_FAIL = "PROFILE_LIST_FAIL";
export const PROFILE_LIST_REQUEST = "PROFILE_LIST_REQUEST";
export const PROFILE_LIST_RESET = "PROFILE_LIST_RESET";
export const PROFILE_LIST_SUCCESS = "PROFILE_LIST_SUCCESS";
